import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { ClientType, getClient } from "./client-registry";

export const instance = <TData = unknown, TVariables = unknown>(
  config: AxiosRequestConfig<TVariables>
): Promise<AxiosResponse<TData>> => {
  return getClient(ClientType.ControlPlane).request<TData>(config);
};

export type ErrorType<Error> = AxiosError<Error>;
